export default __webpack_public_path__ + "static/media/youtube.0e9c4762.svg";